import { defineStore } from 'pinia';

export type TicketPageView = 'dashboard' | 'discussions' | 'detail';

const STORAGE_KEY_VIEW = 'tickets-view-state';
const STORAGE_KEY_TICKET_ID = 'tickets-view-ticket-id';

function readView(): TicketPageView {
  const raw = localStorage.getItem(STORAGE_KEY_VIEW);
  if (raw === 'dashboard' || raw === 'discussions' || raw === 'detail') {
    return raw;
  }

  return 'dashboard';
}

export const useTicketsViewStore = defineStore('ticketsView', {
  state: () => ({
    view: readView() as TicketPageView,
    selectedTicketId: localStorage.getItem(STORAGE_KEY_TICKET_ID) || null,
  }),

  actions: {
    setView(nextView: TicketPageView) {
      this.view = nextView;
      localStorage.setItem(STORAGE_KEY_VIEW, nextView);

      if (nextView !== 'detail') {
        this.clearSelectedTicketId();
      }
    },

    setSelectedTicketId(ticketId: string | null) {
      this.selectedTicketId = ticketId;
      if (!ticketId) {
        localStorage.removeItem(STORAGE_KEY_TICKET_ID);
        return;
      }

      localStorage.setItem(STORAGE_KEY_TICKET_ID, ticketId);
    },

    clearSelectedTicketId() {
      this.selectedTicketId = null;
      localStorage.removeItem(STORAGE_KEY_TICKET_ID);
    },

    reset() {
      this.view = 'dashboard';
      this.selectedTicketId = null;
      localStorage.removeItem(STORAGE_KEY_VIEW);
      localStorage.removeItem(STORAGE_KEY_TICKET_ID);
    },
  },
});
